export const USER_ROLES = {
  SUPER_USER: "Super",
  MD_USER: "MD",
  ADMIN_USER: "Admin",
  HR_USER: "HR",
  EXECUTIVE_USER: "Executive",
  GENERAL_MANAGER: "General Manager",
  MANAGER_USER: "Manager",

  EMPLOYEE_USER: "Employee",
  GUEST_USER: "Guest",
  BOARD_MEMBER_USER: "Board",
};

export const userRolesAccessRights = (role: string) => { };


export const PATERSON_JOB_GRADES = [
  "A1",
  "A2",
  "A3",
  "A4",
  "A5",
  "B1",
  "B2",
  "B3",
  "B4",
  "B5",
  "C1",
  "C2",
  "C3",
  "C4",
  "C5",
  "D1",
  "D2",
  "D3",
  "D4",
  "D5",
  "E1",
  "E2",
  "E3",
  "E4",
  "E5",  
]

export function isJobGradeValid(jobGrade: string): boolean {
  return PATERSON_JOB_GRADES.includes(jobGrade);
}

